import {ManagementTransformBase} from "../TranformBase";

import {ProvidersRecordModel, ProvidersListModel} from "@/api/models";
import {GetWorkspaceProviders200, NameValue} from "@/api/services";

export class ProvidersTransform extends ManagementTransformBase<ProvidersRecordModel> {
  public makeRecordModel(dto: NameValue): ProvidersRecordModel {
    const model: ProvidersRecordModel = {
      name: dto.name,
      value: dto.value,
    };

    return model;
  }

  public makeListModel(dto: GetWorkspaceProviders200): ProvidersListModel {
    const model: ProvidersListModel = {
      records: dto?.items.map(item => this.makeRecordModel(item as NameValue)),
      pagination: this.makePaginationModel(dto),
    };

    return model;
  }
}

export const providersTransform = new ProvidersTransform();
